import React from 'react';
// Data
import { favoriteSessionsArray } from '../../utils/data/ServicesData';
// Images
import FullMainImage from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-face-mask.jpg';
// Constants
import { CONTACT_PAGE_URL } from '../../utils/Constants';

export default function FavouriteServices() {
  return (
    <section className='grid w-full border-b-2 border-solid border-colour7 py-10 lg:pb-16'>
      <div className='grid gap-6 md:gap-10 lg:gap-10 px-6 sm:px-10 md:px-24'>
        {/* Header */}
        <section className='grid text-center pt-8 lg:pt-12 h-fit'>
          <h4 className='text-4xl lg:text-6xl font-titleFont'>
            My <br />
            Favourite Sessions
          </h4>
        </section>

        {/* Grid Layout */}
        <section className='grid'>
          <section className='grid'>
            <div className='grid gap-6 lg:grid-cols-[1fr_auto_1fr]'>
              {/* Left Column */}
              <div className='grid my-auto gap-y-6'>
                {favoriteSessionsArray.slice(0, 3).map((session, index) => (
                  <SessionCard
                    key={session.title}
                    session={session}
                    index={index}
                  />
                ))}
              </div>

              {/* Center Image (Only on large screens) */}
              <div className='flex items-center'>
                <img
                  src={FullMainImage}
                  alt='Mistress Liyah Minx'
                  className='w-64 lg:w-80 rounded-lg shadow-lg mx-auto'
                />
              </div>

              {/* Right Column */}
              <div className='grid my-auto gap-y-6'>
                {favoriteSessionsArray.slice(3, 6).map((session, index) => (
                  <SessionCard
                    key={session.title}
                    session={session}
                    index={index + 3}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* Find Out More Button */}
          <section className='grid'>
            <div className='mt-8 flex justify-center'>
              <a href={CONTACT_PAGE_URL} className=''>
                Find Out More
              </a>
            </div>
          </section>
        </section>
      </div>
    </section>
  );
}

// Individual Session Card
const SessionCard = ({ session, index }) => {
  const borderColor =
    index % 2 === 0 ? 'border-colour5 bg-colour8' : 'border-colour8';

  return (
    <article
      className={`grid h-fit bg-colour2 text-colour1 border-solid border-2 ${borderColor} shadow-colour8/80 px-4 py-2 shadow-cardShadow text-center`}
    >
      <div>
        <h3 className='text-2xl font-titleFont pt-2 tracking-widest'>
          {session.title}
        </h3>
      </div>
      <div>
        <p className='text-colour9'>{session.description}</p>
      </div>
    </article>
  );
};
